// extracted by mini-css-extract-plugin
module.exports = {"desktopMega":"2560px","desktopMed":"1440px","desktop":"1024px","tablet":"768px","mobile":"480px"};